import { createSlice } from '@reduxjs/toolkit';
import { ReviewState } from '../../types';
import { addReviewExtraReducers } from './reviewSlice.extraReducers';
import { reviewCaseReducers } from './reviewSlice.reducers';
import {
  completeReview,
  createOnDemandItem,
  createReview,
  deleteOnDemandItem,
  deleteReview,
  fetchOnDemandItems,
  fetchReviewById,
  fetchReviewItemDetail,
  fetchReviews,
  fetchTemplateDetails,
  fetchTemplates,
  initializeOfflineServices,
  saveAllDrafts,
  submitReview,
  syncOfflineData,
  updateOnDemandItem,
  updateReviewNotes,
  updateReviewOnDemandProjects,
  updateReviewDetails,
  updateReviewResponse,
  updateSubmittedReviewResponse,
} from './reviewSlice.thunks';

const initialState: ReviewState = {
  activeReview: null,
  reviews: [],
  templates: [],
  onDemandItems: {},
  isLoading: false,
  isLoadingReview: false,
  isLoadingOnDemand: false,
  error: null,
  deletedReviewIds: [],
};

const reviewSlice = createSlice({
  name: 'review',
  initialState,
  reducers: reviewCaseReducers,
  extraReducers: (builder) => {
    addReviewExtraReducers(builder, {
      fetchReviews,
      fetchReviewById,
      fetchTemplates,
      fetchTemplateDetails,
      createReview,
      updateReviewResponse,
      updateSubmittedReviewResponse,
      submitReview,
      deleteReview,
      completeReview,
      fetchOnDemandItems,
      createOnDemandItem,
      updateOnDemandItem,
      deleteOnDemandItem,
      updateReviewNotes,
      updateReviewOnDemandProjects,
      updateReviewDetails,
      initializeOfflineServices,
      syncOfflineData,
      saveAllDrafts,
    });
  },
});

export const {
  setActiveReview,
  clearActiveReview,
  updateLocalResponse,
  setError,
} = reviewSlice.actions;

export {
  completeReview,
  createOnDemandItem,
  createReview,
  deleteOnDemandItem,
  deleteReview,
  fetchOnDemandItems,
  fetchReviewById,
  fetchReviewItemDetail,
  fetchReviews,
  fetchTemplateDetails,
  fetchTemplates,
  initializeOfflineServices,
  saveAllDrafts,
  submitReview,
  syncOfflineData,
  updateOnDemandItem,
  updateReviewNotes,
  updateReviewOnDemandProjects,
  updateReviewDetails,
  updateReviewResponse,
  updateSubmittedReviewResponse,
};

export default reviewSlice.reducer;
